var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPincel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95526 2.38787L1.14111 9.20255C1.1068 9.23695 1.08234 9.27993 1.0703 9.327L0.314986 12.3586C0.303878 12.4036 0.304558 12.4507 0.316963 12.4953C0.329367 12.5399 0.353076 12.5806 0.3858 12.6135C0.436062 12.6636 0.504116 12.6917 0.57508 12.6918C0.596971 12.6918 0.618778 12.6891 0.640009 12.6837L3.67158 11.9283C3.71872 11.9165 3.76175 11.892 3.79606 11.8576L10.6108 5.04339L7.95526 2.38787ZM12.299 1.45869L11.5405 0.700191C11.0335 0.193232 10.1499 0.193734 9.64354 0.700191L8.71439 1.62936L11.3698 4.28479L12.299 3.35564C12.5522 3.10251 12.6917 2.76557 12.6917 2.40723C12.6917 2.04889 12.5522 1.71195 12.299 1.45869Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPincel);
export default __webpack_public_path__ + "static/media/Pincel.429b146b201ee5bc33cfb93366dd36a3.svg";
export { ForwardRef as ReactComponent };